import { axiosInstance } from "api/services/axiosInstance";
import { PROJECT_URL, MARKETPLACE_URL } from "constants/ApiConstants";
import qs from "qs";

const marketplaceApi = {
  getOrders: (projectId, searchKeys, cancelToken) => {
    const params = {
      ...searchKeys,
    };
    return axiosInstance.get(`${PROJECT_URL}/${projectId}/orders`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
      cancelToken,
    });
  },
  getOrdersExcelSheet: (projectId, searchKeys) => {
    const params = {
      projectId,
      ...searchKeys,
    };
    return axiosInstance.get(`CsvExport/ExportOnlineOrders`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },
  getDeletedOrders: (projectId, searchKeys, cancelToken) => {
    const params = {
      ...searchKeys,
    };
    return axiosInstance.get(`${PROJECT_URL}/${projectId}/deletedOrders`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
      cancelToken,
    });
  },
  getInterestedExcelSheet: (projectId, searchKeys) => {
    const params = {
      projectId,
      ...searchKeys,
    };
    return axiosInstance.get("CsvExport/ExportInterestedUnits", {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },
  getDeletedOrdersExcelSheet: (projectId, searchKeys) => {
    const params = {
      projectId,
      ...searchKeys,
    };
    return axiosInstance.get(`CsvExport/ExportDeletedOrders`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
  },
  getOrder: (projectId, orderId, cancelToken) =>
    axiosInstance.get(`/org/booking/project/${projectId}/order/${orderId}`, {
      cancelToken,
    }),
  getProjectBatches: (projectId, searchKeys, cancelToken) =>
    axiosInstance.get(
      `${MARKETPLACE_URL}/BackOffice/project/${projectId}/batches`,
      { params: { ...searchKeys }, cancelToken }
    ),
  listProjectBatches: (projectId, batchId) =>
    axiosInstance.put(
      `${MARKETPLACE_URL}/BackOffice/project/${projectId}/batch/${batchId}/list`
    ),
  unListProjectBatches: (projectId, batchId) =>
    axiosInstance.put(
      `${MARKETPLACE_URL}/BackOffice/project/${projectId}/batch/${batchId}/unList`
    ),
  cancelProjectBatches: (projectId, batchId) =>
    axiosInstance.put(
      `${MARKETPLACE_URL}/BackOffice/project/${projectId}/batch/${batchId}/cancel`
    ),
  getLookupType: (lookupType) =>
    axiosInstance.get(`org/booking/lookups${lookupType}`),
  createBatch: (projectId, data) =>
    axiosInstance.post(
      `${MARKETPLACE_URL}/BackOffice/project/${projectId}/batch`,
      data
    ),
  updateBatch: (projectId, batchId, data) =>
    axiosInstance.put(
      `${MARKETPLACE_URL}/BackOffice/project/${projectId}/batch/${batchId}`,
      data
    ),
  getBatchDetails: (projectId, batchId) =>
    axiosInstance.get(
      `${MARKETPLACE_URL}/BackOffice/project/${projectId}/batch/${batchId}`
    ),
  editProjectPaymentPlanSettings: (projectId, data) =>
    axiosInstance.put(
      `${MARKETPLACE_URL}/BackOffice/project/${projectId}/paymentPlansSettings`,
      data
    ),
  editProjectOffPlanSettings: (projectId, data) =>
    axiosInstance.put(
      `${MARKETPLACE_URL}/BackOffice/project/${projectId}/offplan`,
      data
    ),
  editProjectMortgageLoansSettings: (projectId, data) =>
    axiosInstance.put(
      `${MARKETPLACE_URL}/BackOffice/project/${projectId}/SupportMortgageLoans`,
      data
    ),
  getProjectMortgageLoansRequests: (projectId) =>
    axiosInstance.get(`Mortgage/GetMortgageLoanRequests`, {
      params: { projectId },
    }),
  getUnitsGroups: (projectId, searchKeys, cancelToken) =>
    axiosInstance.get(`${MARKETPLACE_URL}/BackOffice/unitGroup`, {
      params: { ...searchKeys, projectId },
      cancelToken,
    }),
  getUnitsGroupDetails: (projectId, id, cancelToken) =>
    axiosInstance.get(
      `${MARKETPLACE_URL}/BackOffice/project/${projectId}/unitGroup/${id}`,
      {
        cancelToken,
      }
    ),
  deleteUnitGroup: (id) =>
    axiosInstance.delete(`${MARKETPLACE_URL}/BackOffice/unitGroup/${id}`),
  createUnitGroup: (data) =>
    axiosInstance.post(`${MARKETPLACE_URL}/BackOffice/unitGroup`, data),
  updateUnitGroup: (id, data) =>
    axiosInstance.put(`${MARKETPLACE_URL}/BackOffice/unitGroup/${id}`, data),
  changeStatus: (id, eVersion) =>
    axiosInstance.put(`${MARKETPLACE_URL}/order/order/${id}/changeStatus`, {
      params: { eVersion },
    }),
  extendPayment: (orderPaymentId, data) =>
    axiosInstance.put(
      `${MARKETPLACE_URL}/backOffice/orders/payment/${orderPaymentId}/extend`,
      data
    ),
  cancelOrder: (orderId, eVersion, data) =>
    axiosInstance.put(
      `${MARKETPLACE_URL}/backOffice/orders/${orderId}/cancel`,
      {
        params: { eVersion },
        data,
      }
    ),
  getBanks: () => axiosInstance.get(`${MARKETPLACE_URL}/BackOffice/Banks`),
  getCancellationReasons: (cancelToken) =>
    axiosInstance.get(`${MARKETPLACE_URL}/order/CancellationReasons`, {
      cancelToken,
    }),
  refundOrder: (data) =>
    axiosInstance.put(`${MARKETPLACE_URL}/backOffice/orders/refund`, data),
  getInterestedUnitsById: (id, cancelToken) =>
    axiosInstance.get(`${MARKETPLACE_URL}/BackOffice/InterestedUnits/${id}`, {
      cancelToken,
    }),
  InterestedUnits: (searchKeys, cancelToken) => {
    return axiosInstance.get(`${MARKETPLACE_URL}/BackOffice/InterestedUnits`, {
      params: {
        ...searchKeys,
      },
      cancelToken,
    });
  },
  verifyAdNumber: (projectParcelId, adNumber) =>
    axiosInstance.put(
      `rega/ValidateUnit/projectParcelId/${projectParcelId}/adNumber/${adNumber}`
    ),
  getOrderReport: (data) => axiosInstance.post(`api/Report/Order`, data),
  getBillReport: (data) => axiosInstance.post(`api/Report/Bill`, data),
};

export default marketplaceApi;
